@if (pageItems(); as pageItems) {
  <ul class="pagination mb-0 user-select-none {{ andClass }}">
    @if (totalItems > 0) {
      <li class="page-item" [class.disabled]="currentPage === 0" (click)="setPage(0, pageItems)">
        <span class="page-link d-none d-md-block">{{ 'common.pagination.first' | translate }}</span>
        <span class="page-link d-block d-md-none"><i class="fa fa-angle-double-left"></i></span>
      </li>
    }
    <li class="page-item" [class.disabled]="currentPage < 1" (click)="setPage(currentPage - 1, pageItems)">
      <span class="page-link d-none d-md-block">{{ 'common.pagination.previous' | translate }}</span>
      <span class="page-link d-block d-md-none"><i class="fa fa-angle-left"></i></span>
    </li>
    @for (pageItem of pageItems; track pageItem) {
      <li class="page-item" (click)="setPage(pageItem.page, pageItems)">
        <span class="page-link" [class.active]="pageItem.page === currentPage">{{ pageItem.label }}</span>
      </li>
    }
    <li class="page-item" [class.disabled]="currentPage === lastPage" (click)="setPage(currentPage + 1, pageItems)">
      <span class="page-link d-none d-md-block">{{ 'common.pagination.next' | translate }}</span>
      <span class="page-link d-block d-md-none"><i class="fa fa-angle-right"></i></span>
    </li>
    @if (totalItems > 0) {
      <li class="page-item" [class.disabled]="currentPage === lastPage" (click)="setPage(lastPage, pageItems)">
        <span class="page-link d-none d-md-block">{{ 'common.pagination.last' | translate }}</span>
        <span class="page-link d-block d-md-none"><i class="fa fa-angle-double-right"></i></span>
      </li>
    }
  </ul>
}
